<div *ngIf="this.viewType !== 'web'">
  <ol
    class="relative space-y-8 before:absolute before:h-full before:w-0.5 before:rounded-full before:bg-gray-200">
    <ng-container *ngFor="let t of  transport; let i = index">
      <li class="relative -ms-2 flex items-start gap-4">
        <span class="size-5 shrink-0 rounded-full bg-blue-600"></span>
        <div class="-mt-0">
          <div class="flex gap-5 items-center">
            <p class="text-xs">{{ t.displayNameFrom }}</p>

            <div *ngIf="!this.data?.viewSettings.isTransportNoteChecked && t?.notes !==''"
                 class="flex justify-center">
              <nz-icon nz-tooltip
                       nzTooltipPlacement='left'
                       [nzTooltipArrowPointAtCenter]="true"
                       [nzTooltipTitle]="t?.notes"
                       [nzTooltipOverlayStyle]="{
                        'max-width': '400px',
                        'min-width': '300px',
                        'white-space': 'normal',
                        'line-height': '1.5'
                      }"
                       nz-icon nzType="info-circle"
                       class="w-6 h-6 text-black bg-white/80 rounded-md shadow-md flex justify-center items-center "
                       nzTheme="outline">
              </nz-icon>
            </div>
          </div>
          <div class="flex flex-wrap  items-center gap-x-3 gap-y-0">
            <lucide-icon
              class="transport-icons transport-active-color flex"
              [name]="getTransportIcon(t.typeOfVehicle)">
            </lucide-icon>
            <span class="text-[16px]" *ngIf="!this.data?.viewSettings.isVehicleNameChecked">{{ t?.transVehicleConfig }}</span>
            <div class="text-[#898989] font-normal text-[16px]">
              <ng-container *ngIf="!this.data?.viewSettings?.isMileageChecked">
                {{ t.mileage }} {{ t.mileageUnit }}
              </ng-container>
            </div>
            <div class="text-[#898989] font-normal text-[16px]">
              <ng-container *ngIf="!this.data?.viewSettings?.isTravelTimeChecked">
                {{ (t?.hours ? t?.hours + " " + this.localizationContent?.hours + " " : '') + (t?.minutes ? t?.minutes + " " + this.localizationContent?.minutes : "") }}
              </ng-container>
            </div>
            <div class="font-normal text-[12px]">
              <ng-container *ngIf="!this.data?.viewSettings?.isVehicleImageChecked && t.vehicleImage !== ''">
                <a [routerLink]="['/client/view-vehicle', t.vehicleImage, t.transVehicleConfig]" target="_blank" rel="noopener noreferrer">
                  View Image
                </a>
              </ng-container>
            </div>
          </div>
        </div>
      </li>
      <li *ngIf="t.displayNameTo !== this.transport[i + 1]?.displayNameFrom"
          class="relative -ms-2 flex items-start gap-4">
        <span class="size-5 shrink-0 rounded-full bg-blue-600"></span>
        <div class="-mt-0">
          <p class="text-xs">{{ t.displayNameTo }}</p>
        </div>
      </li>
    </ng-container>
  </ol>
  <div *ngIf="this.isShowMoreTab" (click)="this.showMore()"
       class="flex flex-row justify-center items-center text-gray-500">
    <span class="text-base ">View All</span>
    <lucide-icon name="chevron-down" class="size-4"></lucide-icon>
  </div>
</div>
<div *ngIf="this.viewType === 'web'">
  <ol class="flex flex-wrap gap-x-4 gap-y-12 items-start list-none">
    <li
      *ngFor="let t of this.transport; let i = index"
      class="min-w-0 flex-1 basis-[280px] md:basis-1/3 xl:basis-1/3 max-w-full"
    >
      <div class="relative mb-3 flex items-center justify-between gap-3">

        <!-- FROM -->
        <span
          class="leading-tight break-words text-[13px] cursor-pointer"
          nz-tooltip
          [nzTooltipTitle]="t.displayNameFrom"
        >
                    {{
            t.displayNameFrom.length > 10
              ? (t.displayNameFrom | slice:0:10) + '...'
              : t.displayNameFrom
          }}
                    </span>

        <!-- duration -->
        <div class="absolute  left-1/2 -translate-x-1/2 text-[#898989] font-normal text-[12px]">
          <ng-container *ngIf="!this.data?.viewSettings?.isTravelTimeChecked">
            {{
              (t?.hours ? t?.hours + ' ' + this.localizationContent?.hours + ' ' : '')
              + (t?.minutes ? t?.minutes + ' ' + this.localizationContent?.minutes : '')
            }}
          </ng-container>
        </div>

        <!-- TO -->
        <div class="min-h-[21px]">
          <span *ngIf="t?.displayNameTo !== this.transport[i + 1]?.displayNameFrom"
                class="text-right break-words text-[13px] cursor-pointer"
                nz-tooltip
                [nzTooltipTitle]="t.displayNameTo">
                        {{
              t.displayNameTo.length > 10
                ? (t.displayNameTo | slice:0:10) + '...'
                : t.displayNameTo
            }}
          </span>
        </div>

      </div>

      <!-- Single baseline line with dots (now the line reaches dot centers) -->
      <div class="relative h-4">
        <!-- extend the line by half the dot width (0.375rem) on both sides -->
        <div
          class="absolute -left-1.5 -right-1.5 top-1/2 -translate-y-1/2 border-t-2 border-dashed border-blue-500"></div>

        <!-- start dot -->
        <span
          class="absolute left-0 top-1/2 -translate-y-1/2 w-3 h-3 bg-blue-500 rounded-full"
          aria-hidden="true"
        ></span>
        <!-- end dot -->
        <span *ngIf="t?.displayNameTo !== this.transport[i + 1]?.displayNameFrom"
              class="absolute right-0 top-1/2 -translate-y-1/2 w-3 h-3 bg-blue-500 rounded-full"
              aria-hidden="true"
        ></span>
      </div>

      <!-- Transport info -->
      <div class="mt-2 flex items-center justify-center gap-2 text-gray-600">
        <lucide-icon
          class="transport-icons transport-active-color flex"
          [name]="getTransportIcon(t.typeOfVehicle)">
        </lucide-icon>
        <span class="text-[12px]" *ngIf="!this.data?.viewSettings.isVehicleNameChecked">{{ t?.transVehicleConfig }}</span>
        →
        <div class="text-[#898989] font-normal text-[12px]">
          <ng-container *ngIf="!this.data?.viewSettings?.isMileageChecked">
            {{ t.mileage }} {{ t.mileageUnit }}
          </ng-container>
        </div>
        <div class="font-normal text-[12px]">
          <ng-container *ngIf="!this.data?.viewSettings?.isVehicleImageChecked && t.vehicleImage !== ''">
            <a [routerLink]="['/client/view-vehicle', t.vehicleImage, t.transVehicleConfig]" target="_blank" rel="noopener noreferrer">
              View Image
            </a>
          </ng-container>
        </div>
      </div>
      <div *ngIf="!this.data?.viewSettings.isTransportNoteChecked && t?.notes !==''"
           class="flex justify-center">
        <nz-icon nz-tooltip
                 nzTooltipPlacement='left'
                 [nzTooltipArrowPointAtCenter]="true"
                 [nzTooltipTitle]="t?.notes"
                 [nzTooltipOverlayStyle]="{
                        'max-width': '400px',
                        'min-width': '300px',
                        'white-space': 'normal',
                        'line-height': '1.5'
                      }"
                 nz-icon nzType="info-circle"
                 class="w-6 h-6 text-black bg-white/80 rounded-md shadow-md flex justify-center items-center "
                 nzTheme="outline">
        </nz-icon>
      </div>
    </li>
  </ol>
</div>
